import React, { Component } from 'react';
import { Session } from '@nackle/arcade-core-v2';
import { loadModule } from '../utils/loader';
import { Alert, Skeleton } from '@nackle/origami';

import { deckUrl } from 'endpoints';

import { auth } from 'config';
import { connect } from 'react-redux';
import './DeckWrapper.less';

const mapStateToProps = ( state ) => ( {
    authState: Session.getAuthState( state ),
    localeLoaded: Session.getLocale( state ),
} );

const mapDispatchToProps = {};

const AppRoot = React.lazy( async () => await loadModule( deckUrl, 'deck', './AppRoot', 'component-deck' ) );

const Fallback = ( { errorDisplay } ) => {
    return (
        <React.Fragment>
            { !errorDisplay && (
                <Skeleton title={ false } paragraph={ { rows: 1 } } />
            ) }
            { errorDisplay && (
                <Alert
                    className="module-error"
                    message={ 'Module load error!' }
                    type="error"
                    closable={ true }
                />
            ) }
        </React.Fragment>
    );
};


class DeckWrapper extends Component {
    state = {
        rgError: false
    };

    fetchApproot = async () => {
        if ( ( await AppRoot._payload._result ) === undefined ) {
            this.setState( {
                rgError: true
            } );
        }
    };
    componentDidMount() {
        this.fetchApproot();
    }

    componentDidCatch( error ) {
        this.setState( { error } );
    }

    render() {
        const { authState, localeLoaded, children } = this.props;
        const { error } = this.state;

        //@ts-ignore
        const locale = localeLoaded.data;

        return (
            ( authState && !error && (
                <React.Suspense
                    fallback={
                        <Fallback errorDisplay={ this.state.rgError } />
                    }
                >
                    <AppRoot
                        auth={ auth }
                        user={ authState }
                        locale={ locale || 'en-US' }
                        guest={ false }
                        footer={ false }
                        leftNav={ false }
                        isDM={ true }
                    >
                        { children }
                    </AppRoot>
                </React.Suspense>
            ) ) || <div />
        );
    }
}

const decorated = connect( mapStateToProps, mapDispatchToProps )( DeckWrapper );
export { decorated as DeckWrapper };
